import { render } from "./StorePage.vue?vue&type=template&id=622fb807&scoped=true"
import script from "./StorePage.vue?vue&type=script&lang=js"
export * from "./StorePage.vue?vue&type=script&lang=js"

import "./StorePage.vue?vue&type=style&index=0&id=622fb807&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622fb807"]])

export default __exports__